
export default function Services() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Connect to high-speed servers across multiple locations worldwide for optimal performance and accessibility.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely private and anonymous.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speed',
      description: 'Enjoy seamless browsing, streaming, and downloading with our optimized server infrastructure.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Secure Connection',
      description: 'Protect your connection on public Wi-Fi networks and prevent unauthorized access to your data.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to assist you with any questions or concerns.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-thin text-gray-900 mb-6">
            Our VPN Services
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience comprehensive protection with our advanced VPN features designed for your security and privacy
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
